import { useForm } from "@core/features/form";
import { codeSchema } from "@platform/features/invitation/dialogs/OrgCodeDialog/orgCodeDialog.schemas";
import { useSubmitCode } from "@platform/features/invitation/hooks/useSubmitCode";
import { InviteCodeForm } from "./InviteCodeForm";

/**
 * Container component for InviteCodeForm.
 * Manages form state and code submission logic.
 */
export function InviteCodeFormContainer() {
  const submitCode = useSubmitCode();

  const { form, handleSubmit } = useForm({
    schema: codeSchema,
    defaultValues: {
      code: "",
    },
    onSubmit: submitCode.mutateAsync,
  });

  const { isSubmitting, isValid, isSubmitSuccessful } = form.formState;

  return (
    <InviteCodeForm
      form={form}
      isSubmitting={isSubmitting}
      isValid={isValid}
      isSubmitSuccessful={isSubmitSuccessful}
      onSubmit={handleSubmit}
    />
  );
}

export default InviteCodeFormContainer;
